AngularService = App.loadClass 'core::Angular/Service'

class exports.ValidationExampleService extends AngularService
    constructor: (@http, $rootScope) ->
        super

    save: (wash, kaylee, jayne, simon) =>
        @http.post '/backend/admin/validation-example/save', {
            wash
            kaylee
            jayne
            simon
        }
